import "/__w/1/s/BotFramework-WebChat/packages/component/src/TextArea/TextArea.module_built.css";
const classes = {"text-area--in-completion":"w4-KLeG_text-area--in-completion","text-area":"w4-KLeG_text-area","text-area-doppelganger":"w4-KLeG_text-area-doppelganger","text-area-input":"w4-KLeG_text-area-input","text-area--scroll":"w4-KLeG_text-area--scroll","text-area-shared":"w4-KLeG_text-area-shared","text-area--hidden":"w4-KLeG_text-area--hidden"}
export default classes

const _text_area__in_completion0 = classes["text-area--in-completion"]
export { _text_area__in_completion0 as "text-area--in-completion" }

const _text_area0 = classes["text-area"]
export { _text_area0 as "text-area" }

const _text_area_doppelganger0 = classes["text-area-doppelganger"]
export { _text_area_doppelganger0 as "text-area-doppelganger" }

const _text_area_input0 = classes["text-area-input"]
export { _text_area_input0 as "text-area-input" }

const _text_area__scroll0 = classes["text-area--scroll"]
export { _text_area__scroll0 as "text-area--scroll" }

const _text_area_shared0 = classes["text-area-shared"]
export { _text_area_shared0 as "text-area-shared" }

const _text_area__hidden0 = classes["text-area--hidden"]
export { _text_area__hidden0 as "text-area--hidden" }
